"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postSavePoint = exports.getBasketBasic = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
const createUrl_1 = require("../../utils/createUrl");
const basketEndpoints = {
    getBasketBasic: { client: 'api/basket/basic' },
    postSavePoint: { client: 'api/basket/savepoint' },
};
const getBasketBasic = (_a, _b) => tslib_1.__awaiter(void 0, [_a, _b], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, { signal }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, basketEndpoints.getBasketBasic, isServer);
    const axiosConfig = {
        method: 'GET',
        url,
        params: defaultRequestParams,
        withCredentials: true,
        signal,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.getBasketBasic = getBasketBasic;
const postSavePoint = (_c) => tslib_1.__awaiter(void 0, [_c], void 0, function* ({ servicesEndpoint, isServer }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, basketEndpoints.postSavePoint, isServer);
    const axiosConfig = {
        method: 'POST',
        url,
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.postSavePoint = postSavePoint;
//# sourceMappingURL=basket.api.js.map